import React from "react";
import colors from "../../../../../styles/colorPalette";
import ButtonTextOnly from "../../../../commons/Buttons/ButtonTextOnly";
import { Wrapper } from "./styled";
import { useHistory } from "react-router-dom";
import { getText } from "./functions";
import { useDispatch } from "react-redux";
import { resetStore } from "../../../../../store/Concept/actions";
import { PATH_COUPON, PATH_FORM } from "../../../../pages/App/constants";

const BackButton = ({ detail }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const goToView = () => {
    if (detail) {
      dispatch(resetStore());
      history.push(PATH_FORM);
    } else {
      history.push(PATH_COUPON);
    }
  };

  return (
    <Wrapper>
      <ButtonTextOnly text={getText(detail)} background={colors.button1} color={colors.blue1} onClick={goToView} />
    </Wrapper>
  );
};

export default BackButton;
